import { usePool } from '@round/creatorbase-helpers/api-hooks';

export function usePoolDetail(poolId: number | null | undefined) {
    const { pool, isLoading, isFetching, isError, errorMessage } = usePool(poolId);

    return {
        pool,
        isLoading,
        isFetching,
        isError,
        errorMessage,
    };
}
